import { render, staticRenderFns } from "./APIUnavailable.vue?vue&type=template&id=50f24487&scoped=true&"
import script from "./APIUnavailable.vue?vue&type=script&lang=js&"
export * from "./APIUnavailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f24487",
  null
  
)

export default component.exports